(()=>{
  const profitFor=({sale,cost,shipping,fees,other})=>{
    const profit=sale-cost-shipping-other-sale*fees/100;
    return {profit,margin:sale>0?profit/sale*100:null};
  };
  const currency=new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency:'EUR'});
  const percentage=new Intl.NumberFormat(document.documentElement.lang||'es',{maximumFractionDigits:1});
  function initialize(scope=document){
    scope.querySelectorAll('[data-vd-calculator]').forEach(form=>{
      if(form.dataset.vdReady)return;form.dataset.vdReady='true';
      function update(){
        const fields=['sale','cost','shipping','fees','other'];
        const values={};let valid=true;
        fields.forEach(name=>{const input=form.elements.namedItem(name);values[name]=input.valueAsNumber;if(!input.validity.valid||!Number.isFinite(values[name]))valid=false;});
        form.querySelector('[data-vd-calc-error]').hidden=valid;
        const result=form.querySelector('.vd-calculator__result');
        if(!valid){form.querySelector('[data-vd-profit]').textContent='–';form.querySelector('[data-vd-margin]').textContent='–';result.removeAttribute('data-negative');return;}
        const {profit,margin}=profitFor(values);
        form.querySelector('[data-vd-profit]').textContent=currency.format(profit);
        form.querySelector('[data-vd-margin]').textContent=margin===null?'–':percentage.format(margin)+' %';
        result.toggleAttribute('data-negative',profit<0);
      }
      form.addEventListener('input',update);form.addEventListener('submit',e=>e.preventDefault());update();
    });
    scope.querySelectorAll('[data-vd-catalog]').forEach(catalog=>{
      if(catalog.dataset.vdReady)return;catalog.dataset.vdReady='true';
      const buttons=Array.from(catalog.querySelectorAll('[data-vd-filter]'));
      const items=Array.from(catalog.querySelectorAll('[data-vd-item]'));
      buttons.forEach(button=>button.addEventListener('click',()=>{
        const selected=button.dataset.vdFilter;let count=0;
        buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        items.forEach(item=>{item.hidden=selected!=='all'&&item.dataset.vdCategory!==selected;if(!item.hidden)count++;});
        const output=catalog.querySelector('[data-vd-count]');if(output)output.textContent=String(count);
      }));
    });
    scope.querySelectorAll('[data-vd-affiliate]').forEach(gallery=>{
      if(gallery.dataset.vdReady)return;gallery.dataset.vdReady='true';
      const cards=Array.from(gallery.querySelectorAll('[data-vd-aff-item]'));
      const search=gallery.querySelector('[data-vd-aff-search]');
      const category=gallery.querySelector('[data-vd-aff-category]');
      function filter(){let count=0;const q=search.value.trim().toLocaleLowerCase();cards.forEach(card=>{card.hidden=!(card.dataset.title.toLocaleLowerCase().includes(q)&&(category.value==='all'||category.value===card.dataset.category));if(!card.hidden)count++;});gallery.querySelector('[data-vd-aff-empty]').hidden=count>0;gallery.querySelector('[data-vd-aff-count]').textContent=String(count);}
      search.addEventListener('input',filter);category.addEventListener('change',filter);
      gallery.querySelector('[data-vd-export]').addEventListener('click',()=>{
        const cell=value=>{let text=String(value);if(/^[=+@\-\t\r]/.test(text))text="'"+text;return '"'+text.replaceAll('"','""')+'"';};
        const rows=[['Producto','Categoría','Precio orientativo','Enlace']];
        cards.filter(card=>!card.hidden).forEach(card=>rows.push([card.dataset.title,card.dataset.category,card.dataset.price,card.querySelector('a').href]));
        const blob=new Blob(['\uFEFF'+rows.map(row=>row.map(cell).join(';')).join('\r\n')],{type:'text/csv;charset=utf-8'});
        const url=URL.createObjectURL(blob);const link=document.createElement('a');link.href=url;link.download='VICIO-SELLERS-productos.csv';link.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
      });
      filter();
    });
  }
  initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('click',event=>{
    const link=event.target.closest('.vp-menu__panel a');
    if(link){const menu=link.closest('details');if(menu)menu.open=false;}
    document.querySelectorAll('[data-vicio-menu][open]').forEach(menu=>{if(!menu.contains(event.target))menu.open=false;});
  });
  document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('[data-vicio-menu][open]').forEach(menu=>{menu.open=false;menu.querySelector('summary').focus();});});
})();
